import { Fragment } from 'react'

import { isLastListItem } from '../../../../utils/common'
import { generateEmptyArray } from '../../../../utils/generate'
import { Divider } from '../../../Divider'
import { WidgetContentSkeleton } from '../../../Widget'

import { ITEMS_COUNT } from './EmailProfileWidgetCopiedToContentSkeleton.constants'

import * as styles from './EmailProfileWidgetCopiedToContentSkeleton.module.css'

function EmailProfileWidgetCopiedToContentSkeleton({
  className = styles.EmailProfileWidgetCopiedToContentSkeleton,
  itemsCount = ITEMS_COUNT,
}) {
  return (
    <div className={className}>
      {generateEmptyArray(itemsCount).map((_, index) => (
        <Fragment key={index}>
          <WidgetContentSkeleton />
          {isLastListItem(itemsCount, index) ? null : (
            <Divider className={styles.divider} />
          )}
        </Fragment>
      ))}
    </div>
  )
}

export default EmailProfileWidgetCopiedToContentSkeleton
